import React, { useState } from 'react';
import '../AboutTeam/AboutTeam.css';

const AboutTeam = () => {
  const [expandedVideo, setExpandedVideo] = useState(null);

  const handleVideoClick = (videoSrc) => {
    setExpandedVideo(videoSrc);
  };

  const closeExpandedVideo = () => {
    setExpandedVideo(null);
  };

  return (
    <section className="about-team-aw">
      <div className='main-top'>
        <div className="about-team-left-aw">
          <img src="s1.jpg" alt="Our Work" loading="lazy" className="team-image-aw" />
        </div>
        <div className="about-team-right-aw">
          <h1 className="about-heading-aw">
            Experiences We've<br />
            <span className="curated-text">
              Curated
            </span>
            <span className="dot">{" "}.</span>
          </h1>
        </div>
      </div>

      <h3 className="about-description-aw">
        From unforgettable weddings{' '}
        <video
          src="/wedding.mp4"
          autoPlay
          loop
          muted
          playsInline
          preload="none"
          className="inline-video-aw"
          onClick={() => handleVideoClick('/wedding.mp4')}
        />{' '}
        to powerful conferences{' '}
        <video
          src="/conference.mp4"
          autoPlay
          loop
          muted
          playsInline
          preload="none"
          className="inline-video-aw"
          onClick={() => handleVideoClick('/conference.mp4')}
        />
        , every event we craft tells a unique story of celebration and success.
      </h3>

      {expandedVideo && (
        <div className="video-overlay-aw" onClick={closeExpandedVideo}>
          <div className="expanded-video-container-aw" onClick={(e) => e.stopPropagation()}>
            <video
              src={expandedVideo}
              autoPlay
              loop
              muted
              playsInline
              preload="none"
              className="expanded-video-aw"
            />
            <button className="close-video-button-aw" onClick={closeExpandedVideo}>
              ×
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default AboutTeam;
